import { render } from "./PengaturanDuaTab.vue?vue&type=template&id=37a281c6"
import script from "./PengaturanDuaTab.vue?vue&type=script&lang=js"
export * from "./PengaturanDuaTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__